import { ServiceBase } from './ServiceBase'

export class Offices extends ServiceBase {}
